/* Related / complementary products for the Larcin V2 carousel
   (sections/larcin-v2-product-carousel.liquid).

   Shopify hands out product recommendations only through its recommendations
   endpoint, so the page renders the chosen collection as a stand-in (or
   nothing, hidden) and this fetches the same section from that endpoint as
   the carousel nears the screen. Recommendations replace the stand-in only
   if there are some; with none, the stand-in stays, or the section stays
   hidden. The carousel inside is a custom element, so it sets itself up
   again when the new markup goes in. */
(() => {
  if (customElements.get('larcin-v2-recommendations')) return;

  class LarcinV2Recommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded || !this.dataset.url) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 600px 0px' }
      );
      this.observer.observe(this.hidden ? this.parentElement : this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      this.dataset.loaded = 'true';
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('larcin-v2-recommendations');
        const hasProducts = fresh && fresh.querySelector('[data-larcin-track] > li');
        if (!hasProducts) return;

        this.replaceChildren(...fresh.childNodes);
        this.dataset.count = fresh.dataset.count || '';
        this.hidden = false;
      } catch (error) {
        // The stand-in (or the hidden section) is the right thing to show when
        // recommendations cannot be loaded, so a failure changes nothing.
      }
    }
  }

  customElements.define('larcin-v2-recommendations', LarcinV2Recommendations);
})();
